import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductionTranslationService } from '../../../core/services/production-translation.service';

/**
 * ÉCRAN DE MAINTENANCE (#1182 lot 2)
 * ==================================
 *
 * Affiché À LA PLACE de l'application quand l'exploitant a levé
 * `maintenance.enabled`. La décision d'afficher n'est pas prise ici : elle vit
 * dans `AppComponent`, qui croise le drapeau avec l'URL courante et le profil
 * du visiteur. Ce composant est purement présentationnel — c'est ce qui permet
 * de le rendre sans Firestore, sans routeur et sans auth.
 *
 * Le bouton « réessayer » recharge la page. C'est volontaire et sans risque
 * ici, contrairement au bandeau de péremption : il n'y a aucune saisie en cours
 * à détruire, l'application n'est pas montée.
 */
@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-maintenance-screen',
  templateUrl: './maintenance-screen.component.html',
  styleUrls: ['./maintenance-screen.component.css'],
})
export class MaintenanceScreenComponent {

  /** Message d'exploitation ; vide ⇒ le gabarit sert le texte traduit. */
  @Input() message = '';

  /** Échéance annoncée ; `null` ⇒ la ligne n'est pas affichée du tout. */
  @Input() until: Date | null = null;

  constructor(public translate: ProductionTranslationService) {}

  reload(): void {
    window.location.reload();
  }
}
